/* eslint react/no-did-mount-set-state: 0 */
import React, { Component } from "react";
//import styled from "styled-components";
import Overdrive from "react-overdrive";
import { Poster } from "./Movie";
import "./MovieDetail.css";
import { getMovieDetails } from '../utils/api';
import { POSTER_PATH, BACKDROP_PATH } from '../utils/const';

let numeral = require("numeral");

class MovieDetail extends Component {
  state = {
    movie: {},
    genres: []
  };

  componentDidMount() { 
    getMovieDetails(this.props.match.params.id).then((movie) => {
      const genres = movie.genres;
      this.setState({
        movie,
        genres
      });
      document.body.style.backgroundImage = `url(${BACKDROP_PATH}${movie.backdrop_path})`;
    });
  }

  componentWillUnmount() { 
    document.body.style.backgroundImage = "";
  }

  render() {
    const { movie } = this.state;
    let totalRevenue = movie.revenue;

    if (totalRevenue === "undefined" || totalRevenue === 0) {
      totalRevenue = "-";
    } else {
      totalRevenue = numeral(movie.revenue).format("($0,0)");
    }

    return (
      <div className="movieInfo">
        <Overdrive id={`${movie.id}`} className="poster">
          <Poster
            src={
              movie.poster_path === null
                ? "http://via.placeholder.com/300x450"
                : `${POSTER_PATH}${movie.poster_path}`
            }
            alt={movie.title}
            className="poster"
          />
        </Overdrive>
        <div className="details">
          <div className="title_wrap">
            <div className="title">{movie.title}</div>
            <div className="tagline meta-data">{movie.tagline}</div>
            <div className="genres">
            {this.state.genres.map(genre => (
              <span className="genre" key={genre.id}> {genre.name} </span>
            ))}</div>
          </div>
          <p className="overview"><strong>Overview:</strong> <br/> {movie.overview} </p>
          <div className="additional_details">
            <div className="realease_date">
              Release Date:
              <div className="meta-data">{movie.release_date}</div>
            </div>
            <div className="runtime">
              Runtime:
              <div className="meta-data">{movie.runtime} min</div>
            </div>
            <div className="totalRevenue">
              Box Office:
              <div className="meta-data">{totalRevenue}</div>
            </div>
            <div className="vote_average">
              Vote Average:
              <div className="meta-data">{movie.vote_average}/10</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default MovieDetail;



// WEBPACK FOOTER //
// ./src/component/MovieDetail.js